import React from 'react';
import { UsersProvider } from '../../../contexts/UsersContext';
import CreateUser from './CreateUser';

export default (props) => {
  return (
    <UsersProvider>
      <CreateUser />
    </UsersProvider>
  );
};
